<template>
  <div class="qrcode">
    <img :src="currentImg" :alt="$t('contact.title')" />
  </div>
</template>

<script>
export default {
  data() {
    return {
      currentImg: require("@/assets/contact.png"),
    }
  },
}
</script>

<style lang="less" scoped>
.qrcode {
  width: 100%;
  margin-top: 5.53vw; /* 87px at 1920px */
  img {
    width: 100%;
    padding: 0;
  }
}
</style>
